import React from "react";

// PARTNER / ADMIN ONLY. The customer, B2B and legal surfaces render the approved 2026 brand
// assets through `components/BrandLogo.jsx`; this component is intentionally left on the previous
// mark because the Partner dashboard is rebranded separately in its own fork.
// The approved Ponesi logo asset already contains its own white app-icon container,
// so it is always rendered as-is: no wrapper, no extra padding, no tint, full opacity.
export const BagLogo = ({ size = 40, className = "" }) => (
  <img
    src="/ponesi-logo-192.png?v=8"
    srcSet="/ponesi-logo-192.png?v=8 1x, /ponesi-logo-384.png?v=8 2x"
    width={size}
    height={size}
    alt="Ponesi"
    className={className}
    style={{ display: "block", objectFit: "contain", opacity: 1 }}
  />
);

// Kept as an alias so brand spots that used a container keep working without double-framing.
export const BagLogoTile = ({ size = 56, className = "" }) => (
  <BagLogo size={size} className={`shrink-0 ${className}`} />
);
